module.exports = __webpack_public_path__ + "img/shrewd-save-2.89342261.jpg";